import { useNavigate } from 'react-router-dom';

import { useAuth } from 'context/AuthContext';
import { NotFound } from 'pages/NotFound';
import Detail from 'pages/MissaoDestaque/Detail';

// Página do item de menu "Realizações do seu prefixo" (Dashboard). A listagem em si é o
// `Detail`, que também segue embutido em outras telas — por isso ela mora onde está e esta
// página apenas a monta com o título próprio e o retorno para a home.
export default function RealizacoesPrefixo() {
  const { user } = useAuth();
  const navigate = useNavigate();

  if (!user) return null;

  // Mesma guarda de MissaoDestaque: o perfil rede não participa de Realização Destaque.
  if (user.extra.rede) return <NotFound />;

  return <Detail title="Realizações do seu prefixo" syncHomeCycle onClose={() => navigate('/')} />;
}
